import {fromMaybe} from '@freckle/maybe'
import Notification from '@freckle/school/ts/common/helpers/notification'
import ApiHelper from './../../helpers/api-helper'

export function logout() {
  const redirect = (redirectUrl: string | null) => {
    document.location.assign(fromMaybe(() => `https://${document.location.host}`, redirectUrl))
  }

  ApiHelper.deleteSessionCookies().then(redirect, () => {
    Notification.displayNotification(
      'error',
      'Could not log you out at this time, please try again later.',
    )
    redirect(null)
    console.error('Could not delete session cookie')
  })
}
